export const environment = {
  production: true,
  
  apiUrl: "https://umyounions.site/api_umyocards/public/api/"
};


